import React from 'react'
import { useSearchParams } from 'react-router'
import { colors, shadow } from '@mobi/component-library/Theme/Common'
import type { FollowMeSharedBet } from '@core/Areas/FollowMe/types'
import { getFollowMeSharedBetByPostId } from '@core/Areas/FollowMe/helpers/api'
import { SharedBetCard } from '@core/Areas/FollowMe/Components/Common/SharedBetCard'

const enum LocalConstants {
  PostIdSearchParam = 'postId',
}

export const IncomingBetNotificationManager: React.FC<{
  onIncomingPostId: (duplicateId: string) => void
}> = ({ onIncomingPostId }) => {
  const [searchParams, setSearchParams] = useSearchParams()
  const [incomingSharedBet, setIncomingSharedBet] = React.useState<FollowMeSharedBet | null>(null)

  const incomingPostId = searchParams.get(LocalConstants.PostIdSearchParam)

  React.useEffect(() => {
    if (!incomingPostId) return
    const postId = incomingPostId

    onIncomingPostId(postId)

    setSearchParams(
      prev => {
        prev.delete(LocalConstants.PostIdSearchParam)
        return prev
      },
      { replace: true }
    )

    getFollowMeSharedBetByPostId(postId).then(sharedBet => {
      if (sharedBet.ticket.status === 'Pending') setIncomingSharedBet(sharedBet)
    })
  }, [incomingPostId, setSearchParams, onIncomingPostId])

  if (!incomingSharedBet) return null

  return <IncomingSharedBet sharedBet={incomingSharedBet} />
}

// ===============
// Local Component
// ===============

const IncomingSharedBet: React.FC<{ sharedBet: FollowMeSharedBet }> = ({ sharedBet }) => {
  const highlightRef = React.useRef<HTMLDivElement>(null)

  React.useEffect(() => {
    if (!highlightRef.current) return

    const el = highlightRef.current
    el.scrollIntoView({ behavior: 'smooth', block: 'center' })

    el.style.transition = 'box-shadow 0.75s ease'
    el.style.boxShadow = `${shadow.sm}, inset 0 0 0 2px ${colors.mariner[500]}`

    const timerId = setTimeout(() => (el.style.boxShadow = ''), 2500)
    return () => clearTimeout(timerId)
  }, [])

  return <SharedBetCard sharedBet={sharedBet} ref={highlightRef} shouldAutoOpenQuickbet />
}
